module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-topbar"
  }, [_c('div', {
    staticClass: "cc-topbar-info"
  }, [_c('h4', {
    staticClass: "cc-topbar-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "cc-topbar-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "cc-topbar-actions"
  }, [(_vm.showHelp) ? _c('button', {
    staticClass: "cc-export-btn",
    attrs: {
      "title": "How this works"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('help')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Help\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "cc-new-chat-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('new-chat')
      }
    }
  }, [_vm._v("+ New Chat")]), _vm._v(" "), _c('button', {
    staticClass: "cc-export-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('export')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-033b52c4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/create-campaign/CampaignTopbar.vue
// module id = HeOB
// module chunks = 1